import {
    update_Places_API_location,
    update_input_states,
    reset_all_states_to_default


} from 'Slices/commonSlices/milleSearchFilter';



//for google location api
export const handleGoogleApiLocation = (value) => dispatch => {
    dispatch(update_Places_API_location(value))
}


//for location input
export const handleInput = (value) => dispatch => {
    dispatch(update_input_states(value))
}


//resetting all fields to normal
export const handleReset = () => dispatch => {
    dispatch(reset_all_states_to_default())
}